
    import { useEffect, useContext, 
        useRef, useState }              from 'react';

    import { Mode }                     from "const";
    
    import { AppContent }               from 'styles/theme';
    import { Background, Content }      from 'styles/proj.components';
    import * as Components              from './components';

    import Ad from 'js/proj/components/global/ad';
    
    import GlobalContext from 'proj/contexts/global';
    
    const DATA_URL = `${CDN}data/data.json`;
    const bannerId = 'ad_bnr_atf_01';
    const mobileBannerId = 'ad_rect_atf_01';

// ------------------------
//  Component
// ------------------------

    export default () =>
    {
        const { active, setData, loadJSON, menuOpen, dimensions, mode } = useContext(GlobalContext);
        const adRef = useRef(null);

        const [adType, setAdType] = useState(null);

    // ------------------------
    //  Initialization
    // ------------------------

        useEffect(() =>
        {
            loadJSON(DATA_URL).then(setData).catch(console.error);
            return () => { }
        }, [])

        useEffect(() =>
        {
            if(adRef.current && active != null)
            {
                const rect = adRef.current.getBoundingClientRect();
                const scrollY = (rect?.height) || 0;
                window.scrollTo({top: scrollY, behavior: 'smooth'});
            }
        }, [active, menuOpen]);

        useEffect(() =>
        {
            setAdType( mode == Mode.MOBILE ? mobileBannerId : bannerId );
        }, [mode])

    // ------------------------
    //  Render
    // ------------------------
        
        return  <AppContent>
                    { adType && <Ad ref={ adRef } id={ adType } className='cnnix--ad' /> }
                    <Content>
                        <Background bgColor={ `#ddf4f6` } width={ dimensions.width || window.innerWidth } height={dimensions.height || window.innerHeight}  />
                        <Components.SiteNav />
                        <Components.Content />
                    </Content>
                </AppContent>
    }